import { React, useEffect, useState, useRef, forwardRef } from 'react';
import { Button, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as api from 'services/api';
import { IoMdAddCircle } from "react-icons/io";
import { CiWarning } from "react-icons/ci";
import { GrPowerReset } from "react-icons/gr";
import { useConfig } from 'contexts/ConfigContext';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useTranslation } from 'react-i18next';
const BlockTimesModal = forwardRef(
    
    function BlockTimesModal({ state, show, setShow, onClose }, ref) {
        const { t } = useTranslation();
        const { configData } = useConfig();
        const { controlCentre } = useControlCentreContext();
        const minutesControlRef = useRef(null);
        
        const defaultBlockingTime = configData.equipmentDefaultBlockingTime;
        const maxBlockingTime = configData.equipmentMaxBlockingTime;
        const minBlockingTime = configData.equipmentMinBlockingTime;

        //#region ----------------------------- STATES -----------------

        const [minsSet, setMinsSet] = useState([]);
        const [initMinSet, setInitMinSet] = useState([]);
        const [error, setError] = useState(null);
        const [success, setSuccess] = useState(null);
        const [showResetWarning, setShowResetWarning] = useState(false);
        const [disableSaveButt, setDisableSaveButt] = useState(true);
        const [confirmRemoval, setConfirmRemoval] = useState(false);
        const [selectorToRemove, setSelectorToRemove] = useState(0);
        //#endregion

        //#region ----------------------------- EFFECTS ----------------

        useEffect(() => {
            if (state.timeset) {
                const minselectors = state.timeset.filter(n => n > 0);
                setMinsSet(minselectors);
                setInitMinSet(minselectors);
            }
        }, [state.timeset])
        //#endregion

        //#region ---------------------------- HANDLERS ----------------


        const handleAddSelector = () => {
            let value = minutesControlRef.current.value ? parseInt(minutesControlRef.current.value) : minBlockingTime
            let repeated = minsSet.find(r => r === value);

            if (repeated) {
                setError(t('ccAlreadySelector'));
                return;
            }
            if (minsSet.length === 5) {
                setError(t('cc5Selectors'));
                return;
            }
            setError(null);
            const newMinsSet = [...minsSet, value];
            newMinsSet.sort((a, b) => a - b);
            setMinsSet(newMinsSet);
            let setChanged = timeSetChanged(initMinSet, newMinsSet)
            if (setChanged) {
                setDisableSaveButt(false);
            } else {
                setDisableSaveButt(true);
            }
            setError(null);
        }

        const handleRemoveSelector = () => {
            const n = selectorToRemove;
            let set = minsSet.filter(r => r !== n);
            setMinsSet(set);
            setConfirmRemoval(false);

            let setChanged = timeSetChanged(minsSet, set)
            if (setChanged) {
                setDisableSaveButt(false);
            } else {
                setDisableSaveButt(true);
            }
        }

        const confirmSelectorRemoval = (n) => {
            setSelectorToRemove(n);
            setConfirmRemoval(true);
        }

        const timeSetChanged = (initset, modset) => {

            initset.sort((a, b) => a - b);
            modset.sort((a, b) => a - b);

            if (initset.every((value, i) => value === modset[i]) && (initset.length === modset.length))
                return false
            else
                return true
        }

        const renderTooltip = (prop) => (
            <Tooltip id="button-tooltip" {...prop}>
                {t('ccRemoveAllTimeSelectors')} ({defaultBlockingTime} mins)
            </Tooltip>
        );
        const handleClose = () => setShowResetWarning(false);
        const handleShow = () => setShowResetWarning(true);

        const handleResetBlockingTimes = async () => {
            try {
                const response = await api.resetBlockingTimeSet(controlCentre.centreid, state.configid, {DefaultValue: defaultBlockingTime});
                if (response.status === 200 && response.data === true) {
                    setError(null);
                    setSuccess(t('ccReturnBlockingTime'));
                    handleClose();
                    setMinsSet([defaultBlockingTime])
                } else {
                    setError(t('ccErrorNotSaved'));
                }
            } catch (error) {
                console.log('ERROR EN EL RESET : ', error);
                setError(t('ccErrorNotSaved'));
            }
        }

        const handleSubmit = async () => {
            setError(null);
            try {
                const response = await api.updateBlockingTimeSet(controlCentre.centreid, state.configid, {BlockingTimeSet : minsSet});
                if (response.status === 200 && response.data === true) {
                    setSuccess(t('ccSelectorsSaved'));
                    setDisableSaveButt(true);
                } else {
                    setError(t('ccErrorNotSaved'));
                }
            } catch (error) {
                setError(t('ccErrorNotSaved'));
            }
        }

        const handleCloseModal = () => {
            setShow(false);
            setError(null);
            setSuccess(null);
            const set = state.timeset.filter(n => n > 0);
            setMinsSet(set);
            setDisableSaveButt(true);
            onClose();
        }

        //#endregion
        return (
            <Modal show={show} onHide={handleCloseModal}
                ref={ref}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('ccTimeSelectors')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table style={{ borderCollapse: 'collapse', border: '1px solid black', marginBottom: '7%' }}>

                        {minsSet.length > 0 ? (
                            <tbody>
                                <tr>

                                    {minsSet.map((n, i) => (
                                        <td key={i} style={{ position: 'relative', border: '1px solid black', padding: '10px', color: 'red' }}>

                                            {minsSet.length > 1 ?
                                                (<button style={{ background: 'none', border: 'none' }} onClick={() => confirmSelectorRemoval(n)}>
                                                    <strong>{n}</strong><small className='ps-2'>mins</small>
                                                </button>) :
                                                (<>
                                                    <strong>{n}</strong><small className='ps-2'>mins</small>
                                                </>)
                                            }
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid black', padding: '10px', color: 'green' }}>
                                        <strong>{defaultBlockingTime}</strong><small className='ps-2'> mins</small>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>

                    {confirmRemoval && (
                        <div className='d-flex flex-row justify-content-center align-items-center'>
                            <p style={{ color: 'red', paddingRight: '3%', marginTop: '2%' }}>{t('ccRemoveSelector')}</p>
                            <Button variant="outline-secondary" className='me-2' size="sm" onClick={handleRemoveSelector}>{t('ccYes')}</Button>
                            <Button variant="outline-secondary" size="sm" onClick={() => setConfirmRemoval(false)}>{t('ccNo')}</Button>
                        </div>
                    )}

                    {success && <p className='text-success fw-semibold'>{success}</p>}
                    {error && <p className="text-danger fw-semibold">{error}</p>}

                    <Form.Label>{t('ccSelectLockout')} : </Form.Label>
                    <div className='d-flex flex-row'>

                        {minBlockingTime !== 0 && (
                            <Form.Control ref={minutesControlRef} max={maxBlockingTime} min={minBlockingTime} type="number" placeholder={minBlockingTime} className='w-auto me-1' />
                        )}
                        <Button variant='none' className='p-0' onClick={handleAddSelector}><IoMdAddCircle style={{ fontSize: '2rem', padding: 2 }} /></Button>
                    </div>
                    <div className='d-flex justify-content-end'>

                        {!showResetWarning && (
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip}
                            >
                                <Button variant='secondary' className='d-flex flex-row py-0' onClick={handleShow} disabled={minsSet.length === 1 && minsSet[0] === defaultBlockingTime}>
                                    <p className='me-2 mt-1'>{t('ccResetSelectors')}</p>
                                    <GrPowerReset className='mt-2' />
                                </Button>
                            </OverlayTrigger>
                        )}

                        {showResetWarning && (
                            <div className='bg-light'>
                                <div className='d-flex flex-row'>
                                    <h1><CiWarning /></h1>
                                    <p className='p-3'>{t('ccResetConfirm')}  </p>
                                </div>
                                <small>{t('ccResetBlockingTime')} ({defaultBlockingTime} mins)</small>
                                <div className='mt-2 text-end'>
                                    <Button variant="secondary" className='me-1' onClick={handleClose}>{t('ccCancel')}</Button>
                                    <Button variant="danger" onClick={handleResetBlockingTimes}>
                                        {t('ccResetConfirm')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='light' onClick={handleCloseModal}>{t('ccClose')}</Button>
                    <Button variant='primary' onClick={handleSubmit} disabled={disableSaveButt}>{t('ccSave')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
)


export default BlockTimesModal;